export default {
  模板内容提示:
    '提示：模板内容仅供参考。会员在本站下载的素材,只拥有使用权,作品著作权及相关权利归本网站所有,未经许可任何人不得擅自使用',
  展台面积: '展台面积',
  展厅高度: '展厅高度',
  灯光要求: '灯光要求',
  文件大小: '文件大小',
  开口方向: '开口方向',
  展台长宽: '展台长宽',
  材质贴图: '材质贴图',
  软件版本: '软件版本',
  模型类型: '模型类型',
  下载需: '下载需',
  金币: '金币',
  立即下载: '立即下载',
  模型作者: '模型作者',
  云展动力签约模型师: '云展动力签约模型师',
  余额不足提示: '提示： 您的账户余额不足,请尽快充值。',
  立即充值: '立即充值',
  模型购买: '模型购买',
  账户余额: '账户余额',
  总价: '总价',
  立即购买: '立即购买',
  取消: '取消',
  价格: '价格',
  模型购买成功提示: '恭喜您,购买成功',
  模型购买成功说明: '您可在个人中心-订单管理查找购买记录,也可以再次下载',
  暂不下载: '暂不下载',
  操作余额不足提示: '很抱歉,您的余额不足,请充值',
}
